<template lang="html">
  <div class="e2e-home page-submenu">
      <div class="e2e-container" style="display: flex;justify-content:space-between;">
          <div class="page-submenu_left">
            <div class="e2e-content-box">
                <left-bar tab='user-manual'></left-bar>
            </div>
          </div>
          <div class="page-submenu_right">
            <div class="e2e-content-box">
                <div class='manual-container'>
                    <div class="manual-desc">如您有任何关于会议计划平台以及会议活动相关的问题或建议，可以下载手册文档以获取帮助,或欢迎点击以下链接访问 gSite。</div>
                    <div class="manual-desc"><a href="https://sites.google.com/roche.com/eme-sharing-g-site/home" target="_blank">https://sites.google.com/roche.com/eme-sharing-g-site/home</a></div>

                    <FileBox
                        style="margin-top: 32px;margin-bottom: 100px"
                        :fileList.sync="fileList"
                        :disabled="true"
                        :disabledDelete="true"
                        :autoUpload="false"
                        :lineNum = "2"
                        accept="pdf,image"
                        :label = "$t('home.manual')"
                        :download="true"
                    />
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import LeftBar from '../LeftBar';
import FileBox from '@/components/common/upload/FileBox.vue';
import _ from 'lodash';

import { downloadManual, getManualInfo } from '@/api/home/manual';

export default {
  components: {
    LeftBar,
    FileBox
  },
  data() {
    return {
      fileList: [],
      hco: undefined,
      hospital_level: undefined
    };
  },
  methods: {
    handleDownloadManual() {
      let filePath = '';
      if (this.fileList.length) {
        const manualFile = this.fileList[0];
        filePath = manualFile.fileS3Path;
      }
      const form = {
        fileS3Url: filePath
      };
      downloadManual(form)
        .then((res) => {
          this.$checkFileStream(res)
            .then(() => {
              this.$downloadFile(res.data, res);
            }, (err) => {
              console.error('err', err);
              this.$message.error(this.$t('popup.download_fail'));
            });
        });
    },
    // 获取用户手册信息
    loadManualInfo() {
      this.fileList = 
      [
            {
              "id": "1174511106530525186",
              "createBy": "admin",
              "createTime": "2020-11-24 17:33:22",
              "type": "0",
              "fileName": "会议计划平台用户手册V1.0.pdf",
              "fileS3Path": "会议计划平台用户手册V1.0.pdf",
              "fileSize": 5248906,
              "description": "会议计划平台用户手册V1.0",
              "delFlag": "0"
            },
        ]
    },
  },
  mounted() {
    this.loadManualInfo();
  }
};
</script>

<style lang="less" scoped>

.manual-container{
    padding: 36px 80px;

    .manual-desc{
        height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        letter-spacing: 1px;
    }

    .manual-desc + .manual-desc {
      margin-top: 24px;
    }
}

.download-btn{
    height: 32px;
    background: @mainColor;
    border: 1px solid @mainColor;
    border-radius: 4px;
    padding: 4px 15px 4px 18px;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// index.vue?5f8de892